import checkRule from './checkRule';

import type {
  InputConditionalLogic,
  FormValuesById,
} from '@monoimin/forms/gravity-form/types';

export const showByConditionalLogic = ({
  conditionalLogic,
  formValuesById,
}: {
  conditionalLogic: InputConditionalLogic | string;
  formValuesById: FormValuesById;
}) => {
  if (!conditionalLogic || typeof conditionalLogic === 'string') {
    return true;
  }

  const { rules, enabled } = conditionalLogic || {};
  if (!enabled) return true;
  return checkRule(rules[0], formValuesById);
};

export default showByConditionalLogic;
